<template>
  <div class="container-fluid clinic-appointments">
    <div class="row" style="margin-top: 40px">
      <div class="col">
        <h1 class="clinic-appointments__title">CITAS REALIZADAS</h1>
      </div>
    </div>

    <!-- Appointment Selector -->
    <div class="clinic-appointment-customers__inputs row form-group">
      <div class="col-sm-6">
        <v-select multiple class="wabident-selector" @search="searchProducts" :filterable="false" :options="products"
          placeholder="Busca el tratamiento/producto aquí ..." v-model="selected_products"></v-select>
        <label class="wabident-info">Tratamiento</label>
      </div>
      <div class="col-sm-6">
        <v-select class="wabident-selector" @search="searchCustomers" :options="customers" :filterable="false"
          placeholder="Busca el paciente aquí" v-model="selected_customer"></v-select>
        <label class="wabident-info">Paciente</label>
      </div>
    </div>

    <legend style="font-weight: bold; font-size: 0.7rem">FILTROS</legend>

    <div class="clinic-appointment-customers__inputs row form-group">
      <!-- ClinicSelector -->
      <div v-if="show_clinic_selector" class="col-sm-2">
        <select id="clinic_appointments_clinic_id" v-model="clinic_id" class="custom-select">
          <option :value="null">Todas</option>
          <option v-for="(name, id) in clinics" :key="id" :value="id">
            {{ name }}
          </option>
        </select>
        <label for="clinic_appointments_clinic_id" class="wabident-info">Clínica</label>
      </div>

      <!-- DoctorSelector -->
      <div class="col-sm-2">
        <select id="clinic_appointments_doctor_id" v-model="doctor_id" class="custom-select">
          <option :value="null">Todos</option>
          <option v-for="(doctor, index) in doctors" :key="index" :value="doctor.doctor.id">
            {{ doctor.name }}
          </option>
        </select>
        <label for="clinic_appointments_doctor_id" class="wabident-info">Doctor</label>
      </div>

      <div class="col-sm-2">
        <select id="clinic_appointments_show_status" v-model="status" class="custom-select">
          <option :value="null">Todos</option>
          <option value="gone">Terminadas</option>
          <option value="pending">Pendientes</option>
          <option value="cancel">Canceladas</option>
        </select>
        <label for="clinic_appointments_show_status" class="wabident-info">Estado</label>
      </div>

      <div class="col-sm-2">
        <select id="clinic_appointments_show_category" v-model="product_category_id" class="custom-select">
          <option :value="null">Todas</option>
          <option v-for="(cat, id) in categories" :value="cat.id" :key="id">
            {{ cat.name }}
          </option>
        </select>
        <label for="clinic_appointments_show_category" class="wabident-info">Categoría/Unidad</label>
      </div>

      <div class="col-sm-2" v-if="product_category_id">
        <div class="form-check form-check-inline mb-2">
          <input v-model="product_category_children" type="checkbox" class="form-check-input" value="true"
            id="product_category_children" />
          <label class="form-check-label" for="product_category_children">Incluir sub-unidades </label>
        </div>
      </div>

    </div>

    <!-- Period Selector -->
    <div class="clinic-appointments__inputs row form-group">

      <div class="col-sm-2">
        <select id="clinic_appointments_order_by_dir" v-model="order_by_dir" class="custom-select">
          <option value="desc">Recientes</option>
          <option value="asc">Antiguas</option>
        </select>
        <label for="clinic_appointments_order_by" class="wabident-info">Sentido</label>
      </div>

      <div class="col-sm-2">
        <select id="clinic_appointments_period" v-model="period" class="custom-select">
          <option value="day">Hoy</option>
          <option value="day_prior">Ayer</option>
          <option value="week">Esta semana</option>
          <option value="week_prior">Semana pasada</option>
          <option value="month">Este mes</option>
          <option value="month_prior">Mes pasado</option>
          <option value="trimester">Este trimestre</option>
          <option value="trimester_prior">Trimestre pasado</option>
          <option value="year">Este año</option>
          <option value="past_year">Año pasado</option>
          <option value="custom">Personalizado</option>
        </select>
        <label for="clinic_appointments_period" class="wabident-info">Periodo</label>
      </div>
      <!-- Custom Dates Selector -->
      <transition name="fade">
        <div class="col-sm-2" v-if="period == 'custom'">
          <input v-model="date_from" id="clinic_appointments_date_from" type="date" class="form-control" />
          <label class="wabident-info" for="clinic_appointments_date_from">Desde:</label>
        </div>
      </transition>

      <transition name="fade">
        <div class="col-sm-2" v-if="period == 'custom'">
          <input v-model="date_to" id="clinic_appointments_date_to" type="date" class="form-control" />
          <label class="wabident-info" for="clinic_appointments_date_to">Hasta:</label>
        </div>
      </transition>

      <!-- AppointmentSelector -->
      <div class="
              col
              clinic-appointments__summary
              d-flex
              flex-row
              justify-content-end
              align-items-start
            ">
        <div class="mx-3" style="margin-top: 2px">
          <select id="clinic_report_type" v-model="report_type" class="custom-select">
            <option value="xls">Listado Excel</option>
          </select>
          <label for="clinic_report_type" class="wabident-info">Tipo de Informe</label>
        </div>

        <button :disabled="is_loading" @click="generateReportPDF" class="
                btn btn-primary btn-wabident
                float-right
                d-flex
                justify-content-center
                align-items-center
              ">
          <i class="fas fa-download"></i>&nbsp;Descargar
        </button>
      </div>
    </div>

    <div v-if="!is_loading" class="row my-4">
      <div class="col-md-2" v-if="total_appointments">
        <h5>TOTAL CITAS</h5>
        <b>{{ total_appointments }}</b>
      </div>
    </div>

    <div v-if="!is_loading" class="clinic-appointments__list">
      <table class="table">
        <thead>
          <tr>
            <th>FECHA</th>
            <th>DUR.</th>
            <th v-if="show_clinic_selector">CLINICA</th>
            <th>PACIENTE</th>
            <th>DOCTOR</th>
            <th>TTOS</th>
            <th>CAT/UNIDAD</th>
            <th>ESTADO</th>
          </tr>
        </thead>
        <tbody>
          <template v-for="(app, index) in search_appointments">
            <tr :key="index">
              <td> {{ appDate(app) }}</td>
              <td> {{ appDuration(app) }}m</td>
              <td v-if="show_clinic_selector">{{ appClinic(app) }}</td>
              <td>
                <a :href="`/customer/${app.customer_id}/edit`" target="_blank" style="color: var(--theme-color)">
                  {{ app.customer.full_name }}
                </a>
              </td>
              <td>{{ app.doctor.user.name }}</td>
              <td>{{ appTreatments(app) }}</td>
              <td>{{ appUnit(app) }}</td>
              <td>{{ appState(app) }}</td>
            </tr>
          </template>
        </tbody>
      </table>

      <div v-if="has_results_available" class="row">
        <div class="col text-center customer-search-pagination my-2">
          <button :disabled="is_first_page" @click="goFirst" type="button"
            class="btn btn-primary btn-wabident-round mx-1">
            <i class="fas fa-angle-double-left"></i>
          </button>
          <button :disabled="is_first_page" @click="goPrev" type="button"
            class="btn btn-primary btn-wabident-round mx-1">
            <i class="fas fa-angle-left"></i>
          </button>
          <label class="customer-search-pagination-locator mx-2">
            Página
            {{ current_page }} de {{ total_pages }}
          </label>
          <button :disabled="is_last_page" @click="goNext" type="button"
            class="btn btn-primary btn-wabident-round mx-1">
            <i class="fas fa-angle-right"></i>
          </button>
          <button :disabled="is_last_page" @click="goLast" type="button"
            class="btn btn-primary btn-wabident-round mx-1">
            <i class="fas fa-angle-double-right"></i>
          </button>
        </div>
      </div>
    </div>
    <div v-else class="clinic-appointments__loading text-center">
      <h2>
        Buscando
        <i class="fas fa-spin fa-circle-notch"></i>
      </h2>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      status: null,
      order_by_dir: "desc",
      is_loading: false,
      period: "day",
      date_from: new Date().toISODate(),
      date_to: new Date().toISODate(),
      doctor_id: null,
      clinic_id: null,
      product_category_id: null,
      product_category_children: null,
      appointments: [],
      summary: [],
      page: 1,
      selected_products: [],
      products: [],
      product_categories: [],
      customers: [],
      selected_customer: null,
      report_type: "xls",
      clinic_boxes: {},
      hierarchy: [],
    };
  },
  computed: {
    categories() {
      let ret = [];
      this.hierarchy.forEach((cat) => {
        this.addCategory(cat, ret, 0);
      });
      return ret;
    },
    clinics() {
      if (!this.clinic) return [];
      return this.clinic.clinic_names;
    },
    doctors() {
      if (!this.clinic) return [];
      return this.clinic.doctors;
    },
    is_first_page() {
      if (!this.has_results_available) return true;
      return this.appointments.current_page == 1;
    },
    is_last_page() {
      if (!this.has_results_available) return true;
      return this.appointments.current_page == this.appointments.last_page;
    },
    search_appointments() {
      if (this.is_loading) return [];
      if (!this.appointments) return [];
      if (!this.appointments.data) return [];
      return this.appointments.data;
    },
    current_page() {
      if (!this.has_results_available) return 0;
      return this.appointments.current_page;
    },
    total_pages() {
      if (!this.has_results_available) return 0;
      return this.appointments.last_page;
    },
    total_appointments() {
      if (!this.has_results_available) return 0;
      return this.appointments.total;
    },
    has_results_available() {
      if (this.is_loading) {
        return false;
      }

      if (!this.appointments) {
        return false;
      }

      if (!this.appointments.data) {
        return false;
      }

      return this.appointments.data.length > 0;
    },
    show_clinic_selector() {
      return Object.keys(this.clinics).length > 1;
    },
    ...mapGetters(["msgwindow", "clinic", "errorwindow", "is_core"]),
  },
  watch: {
    doctor_id(val) {
      this.reloadAppointments();
    },
    product_category_id(val) {
      this.reloadAppointments();
    },
    product_category_children(val) {
      this.reloadAppointments();
    },
    period(val) {
      this.reloadAppointments();
    },
    date_from(val) {
      this.reloadAppointments();
    },
    date_to(val) {
      this.reloadAppointments();
    },
    clinic_id(val) {
      this.reloadAppointments();
    },
    order_by_dir(val) {
      this.reloadAppointments();
    },
    selected_products(val) {
      this.reloadAppointments();
    },
    selected_customer(val) {
      this.reloadAppointments();
    },
    status(val) {
      this.reloadAppointments();
    }
  },
  methods: {
    appClinic(app) {
      let clinic_id = this.clinic_boxes[app.box_id];
      if (!clinic_id) return 'N/D';

      return this.clinics[clinic_id] || 'N/D';
    },
    appDate(app) {
      return moment(app.date_from).format('DD/MM/YYYY');
    },
    appDuration(app) {
      const from = moment(app.date_from);
      const to = moment(app.date_to);

      return moment.range(from, to).diff('minutes');
    },
    appTreatments(app) {
      if (app.is_first) {
        return 'Primera Visita';
      }

      if (app.treatments.length) {
        return app.treatments.map((t) => {
          return t.product.name;
        }).join(', ');
      }

      return '';
    },
    appState(app) {
      switch (app.status) {
        case 'arrived':
          return 'Llegada';
        case 'attended':
          return 'Atendida';
        case 'treated':
          return 'Tratada';
        case 'cancel':
          return 'Cancelada';
        case 'absent':
          return 'Ausente';
        case 'leaving':
          return 'Saliendo';
        case 'gone':
          return 'Terminada';
      }

      if (app.is_confirmed) {
        return 'Confirmada';
      }
      return 'Pendiente';
    },
    appUnit(app) {
      if (app.is_first) {
        return this.product_categories[app.product_category_id] || '';
      }

      if (app.treatments.length) {
        return app.treatments.map((t) => {
          const pid = t.product.product_category_id;
          return this.product_categories[pid] || '';
        }).join(', ');
      }

      return '';
    },
    reloadAppointments() {
      this.page = 1;
      this.loadAppointments();
    },
    goFirst() {
      this.page = 1;
      this.loadAppointments();
    },
    reloadAppointments() {
      this.page = 1;
      this.loadAppointments();
    },
    goFirst() {
      this.page = 1;
      this.loadAppointments();
    },
    goPrev() {
      this.page -= 1;
      this.loadAppointments();
    },
    goNext() {
      this.page += 1;
      this.loadAppointments();
    },
    goLast() {
      this.page = this.total_pages;
      this.loadAppointments();
    },
    fillSearchedProducts(products) {
      this.searched_products = products;
      this.products = products.map((p) => {
        return {
          label: p.name,
          value: p.id,
        };
      });
    },
    fillSearchedCustomers(customers) {
      this.searched_customers = customers;
      this.customers = customers.map((p) => {
        return {
          label: `${p.full_name} - #${p.history_number}`,
          value: p.id,
        };
      });
    },
    searchProducts(search, loading) {
      loading(true);
      axios
        .get("/product", {
          params: {
            search: search,
          },
        })
        .then((response) => {
          this.fillSearchedProducts(response.data.data);
        })
        .catch((error) => {
          console.log("[ERR] searchProducts:", error);
        })
        .then(() => {
          loading(false);
        });
    },

    searchCustomers(search, loading) {
      loading(true);
      axios
        .get("/customer/search", {
          params: {
            search: search,
          },
        })
        .then((response) => {
          this.fillSearchedCustomers(response.data);
        })
        .catch((error) => {
          console.log("[ERR] searchCustomers:", error);
        })
        .then(() => {
          loading(false);
        });
    },

    userCan(cap) {
      if (!this.clinic) return false;
      if (!this.clinic.capabilities) return false;
      return this.clinic.capabilities[cap] || false;
    },
    generateReportPDF() {
      let params = {
        period: this.period,
        date_from: this.date_from,
        date_to: this.date_to,
        doctor_id: this.doctor_id,
        derived_by: this.derived_by,
        clinic_id: this.clinic_id,
        report_type: this.report_type,
        show_paid: this.show_paid,
        show_done: this.show_done,
        order_by: this.effective_order_by,
        order_by_dir: this.order_by_dir,
        product_id: this.getSelectedProductId(),
        product_ids: this.getSelectedProductsIds(),
        customer_id: this.getSelectedCustomerId(),
        status: this.status,
        product_category_id: this.product_category_id,
        product_category_children: Boolean(this.product_category_children) ? 1 : 0,
      };

      let query_params = [];
      for (let field in params) {
        let val = params[field];
        if (Array.isArray(val)) {
          val.forEach(function (v) {
            query_params.push(`${field}[]=${v}`);
          });
        } else if (val) {
          query_params.push(`${field}=${params[field]}`);
        }
      }

      let url = "/clinic/appointments?" + query_params.join("&");
      window.open(url, "_blank");
    },
    getSelectedProductsIds() {
      return this.selected_products.map((x) => {
        return x.value;
      });
    },
    getSelectedProductId() {
      if (!this.selected_product) return null;
      return this.selected_product.value;
    },
    getSelectedCustomerId() {
      if (!this.selected_customer) return null;
      return this.selected_customer.value;
    },
    loadCategories() {
      axios
        .get("/product/hierarchy")
        .then((response) => {
          this.hierarchy = response.data;
        });
    },
    addCategory(cat, ret, level) {
      let prefix = '-'.repeat(level);

      ret.push({
        id: cat.id,
        slug: cat.slug,
        name: prefix + cat.name,
        parent_id: cat.parent_id,
        level: level
      });

      cat.children.forEach((subcat) => {
        this.addCategory(subcat, ret, level + 1);
      });
    },
    loadAppointments() {
      if (!this.is_loading) {
        this.is_loading = true;
        let params = {
          period: this.period,
          date_from: this.date_from,
          date_to: this.date_to,
          doctor_id: this.doctor_id,
          derived_by: this.derived_by,
          clinic_id: this.clinic_id,
          show_paid: this.show_paid,
          show_done: this.show_done,
          order_by: this.effective_order_by,
          order_by_dir: this.order_by_dir,
          page: this.page,
          customer_id: this.getSelectedCustomerId(),
          product_ids: this.getSelectedProductsIds(),
          status: this.status,
          product_category_id: this.product_category_id,
          product_category_children: Boolean(this.product_category_children) ? 1 : 0,
        };

        axios
          .get("/clinic/appointments", { params })
          .then((response) => {
            this.appointments = response.data.results;
            this.product_categories = response.data.product_categories;
            this.page = response.data.results.current_page;
            this.summary = response.data.summary;
            this.date_from = response.data.params.date_from;
            this.date_to = response.data.params.date_to;
            this.clinic_boxes = response.data.clinic_boxes;
          })
          .catch((error) => {
            console.log("[ERR] loadAppointments ", error);
            this.msgwindow.error("Error cargando tratamientos realizados");
          })
          .then(() => {
            this.is_loading = false;
          });
      }
    },
  },
  mounted() {
    this.clinic_id = this.clinic.id;
    this.loadAppointments();
    this.loadCategories();
  },
};
</script>

<style lang="scss">
.clinic-appointments {
  max-width: 1440px;

  &__title {
    font-size: 32px;
  }

  &__list {
    table {
      th {
        font-size: 15px;
        letter-spacing: 0.3px;
        color: var(--theme-grey);
        border: none;
        position: sticky;
        top: 0;
        z-index: 1;
        background: white;
        border-bottom: 1px #e0e0e0 solid;
      }

      &__row {
        cursor: pointer;
        background-color: transparent;
        transition: all 0.2s;
        border-bottom: 1px #e0e0e0 solid;
        border-top: 1px #e0e0e0 solid;

        &:hover {
          background-color: var(--theme-highlight);
        }

        td {
          font-size: 16px;
          line-height: 20px;
          color: var(--theme-text-color);
        }
      }
    }
  }
}
</style>
